import React from "react";

export const RadioBoxParts = ({id, register, name, value, label, checked, onChange}) => {
    
    return (
        <>
        <input 
        type="radio" 
        name={name} 
        value={value}
        id={id}
        {...register(name)} 
        />
        <label htmlFor={id}>{label}</label>
        </>
    )
}